import './App.css';
import Card_Logger from './components/Card_Logger';

function App() {
  return (
    <div className="App">
      <Card_Logger></Card_Logger>
    </div>
  );
}

export default App;
